import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader } from '@livable/saas-react-components';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from '@mui/material';
// import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import BillDetails from './billDetails';
import { MeterDetails } from './MeterDetails';
import useStyles from './styles';
export const ApplyBillingFullContent = observer(_ref => {
  var _property$allocations;
  let handleClose = _ref.handleClose,
    _ref$property = _ref.property,
    property = _ref$property === void 0 ? {} : _ref$property;
  const classes = useStyles();
  const store = useStore();
  // const { t } = useTranslation();
  const page = 'Apply Billing';
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const applyBill = currentCompany.billingTab.applyBill || {};
  const billingCycleId = applyBill.billingCycleId;
  const propertyId = property.id;
  const showPreview = applyBill.status === 'PendingApproval' || applyBill.status === 'TableReady' || applyBill.status === 'TableReadyStatementSent';
  const utility = (_property$allocations = property.allocations) === null || _property$allocations === void 0 ? void 0 : _property$allocations.utilityById.get(billingCycleId + applyBill.utilityId);
  const utilityId = applyBill.utilityId;
  const getAllocationComparison = async data => {
    const resp = await store.allocations.getAllocationComparisonAsync.run(data);
    return resp;
  };
  const getAllocationTable = async data => {
    const resp = await store.allocations.getAllocationTableAggregateAsync.run(data);
    return resp;
  };
  const isOpen = currentCompany.billingTab.isApplyBillingIsOpen;
  useEffect(() => {
    if (!isOpen || !billingCycleId || !propertyId || !utilityId) {
      return;
    }
    if (showPreview) {
      currentCompany.billingTab.setIsModalLoading(true);
      getAllocationTable({
        billingCycleId,
        propertyId,
        utilityId
      }).then(() => getAllocationComparison({
        billingCycleId,
        propertyId,
        utilityId
      })).finally(() => currentCompany.billingTab.setIsModalLoading(false));
    } else if (applyBill.status === 'PendingCompletion') {
      currentCompany.billingTab.setIsModalLoading(true);
      getAllocationComparison({
        billingCycleId,
        propertyId,
        utilityId
      }).finally(() => currentCompany.billingTab.setIsModalLoading(false));
    }
  }, [applyBill.status, billingCycleId, isOpen, propertyId, showPreview, utilityId]);
  useEffect(() => {
    var _property$allocations2, _utility$bill, _utility$bill2, _property$allocations3, _property$allocations4;
    (_property$allocations2 = property.allocations) === null || _property$allocations2 === void 0 || _property$allocations2.setTempFileData('isShared', utility !== null && utility !== void 0 && (_utility$bill = utility.bill) !== null && _utility$bill !== void 0 && _utility$bill.isShared ? utility === null || utility === void 0 || (_utility$bill2 = utility.bill) === null || _utility$bill2 === void 0 ? void 0 : _utility$bill2.isShared : (_property$allocations3 = property.allocations) !== null && _property$allocations3 !== void 0 && (_property$allocations3 = _property$allocations3.tempFileData) !== null && _property$allocations3 !== void 0 && _property$allocations3.isShared ? (_property$allocations4 = property.allocations) === null || _property$allocations4 === void 0 || (_property$allocations4 = _property$allocations4.tempFileData) === null || _property$allocations4 === void 0 ? void 0 : _property$allocations4.isShared : false);
  }, [utility]);
  const isSubmeterUtility = store.account.featureFlagsStore.getEnableSubmeterBilling && ((utility === null || utility === void 0 ? void 0 : utility.allocationMethod) === 'BySubmeter' || applyBill.allocationMethod === 'Submeter');
  // Once the statement is sent out there is nothing to edit on the bill side —
  // only the (read-only) meter details are relevant.
  const isStatementSent = applyBill.status === 'TableReadyStatementSent';
  const _useState = useState(isStatementSent ? 'meter' : 'bill'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.modalData
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: currentCompany.billingTab.isModalLoading
  }), isSubmeterUtility && /*#__PURE__*/React.createElement("div", {
    className: classes.contentTabs
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: selectedTab,
    onChange: (_, v) => {
      track(events.tabNavigated(), {
        page,
        tab: v === 'meter' ? 'Meter details' : 'Bill details'
      });
      setSelectedTab(v);
    }
  }, !isStatementSent && /*#__PURE__*/React.createElement(Tab, {
    label: "Bill details",
    value: "bill"
  }), /*#__PURE__*/React.createElement(Tab, {
    label: "Meter details",
    value: "meter"
  }))), (!isSubmeterUtility || selectedTab === 'bill') && /*#__PURE__*/React.createElement(React.Fragment, null, showPreview && !isSubmeterUtility && !currentCompany.billingTab.isBillEdit ? null : /*#__PURE__*/React.createElement("div", {
    className: classes.formTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Bill details"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Enter your bill details to be able to charge your residents.")), /*#__PURE__*/React.createElement(BillDetails, {
    handleClose: handleClose,
    property: property,
    showPreview: isSubmeterUtility ? false : showPreview,
    isSubmeterUtility: isSubmeterUtility,
    onSubmeterBillSaved: () => setSelectedTab('meter')
  })), isSubmeterUtility && selectedTab === 'meter' && /*#__PURE__*/React.createElement(MeterDetails, {
    propertyId: propertyId,
    utilityId: utilityId,
    billingCycleId: billingCycleId
  }));
});